import { Scale } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useComparison } from '../hooks/ComparisonContext';
import { tx } from '../i18n';
import LanguageSwitch from './LanguageSwitch';

/** Thin, persistent header. The comparison counter lives here so the free limit is always visible. */
export default function SiteHeader() {
  const { comparison } = useComparison();
  const count = comparison?.rows.length ?? 0;

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="brand" aria-label="ScanHome">
          <img src="/logo.png" alt="ScanHome" className="brand__logo" width={198} height={48} />
        </Link>

        <nav className="site-header__nav">
          <Link to="/compare" className="nav-link">
            <Scale size={16} aria-hidden="true" />
            {/* The word is hidden at phone width, where the icon and the counter carry it; the
                text stays in the DOM so the link keeps its accessible name. */}
            <span className="nav-link__label">
              {tx('Compare', 'Karşılaştır', 'Porównaj', 'Comparar', 'Comparar')}
            </span>
            {count > 0 ? <span className="nav-link__count">{count}</span> : null}
          </Link>
          <LanguageSwitch />
        </nav>
      </div>
    </header>
  );
}
